module.exports = __webpack_public_path__ + "static/media/pending.f16ce008.svg";